// extracted by mini-css-extract-plugin
export var hidden = "_4b-1";
export var leftPanel = "_4b-2";
export var readonlyInspector = "_4b-3";
export var rightPanel = "_4b-0";